module.exports = __webpack_public_path__ + "img/franciscacrovetto.79469f79.jpg";